module.exports = __webpack_public_path__ + "static/ExtendIT-Slider1-68bfe078d74a900ffecdd3ca8b091a1f.jpg";